import { ZodSchema } from "@validation/utils/schemaUtils";
import z from "zod";

export const gasolineStaffelSchema = z.object({
	id: z.number().nullable(),
	description: z.string().min(1).max(255),
	staffelItems: z.array(z.object({
		id: z.number().nullable(),
		startPrice: ZodSchema.requiredField(z.number().min(0).max(9999999)),
		endPrice: ZodSchema.requiredField(z.number().min(0).max(9999999)),
		surcharge: ZodSchema.requiredField(z.number().min(-100).max(500)),
	})),
});

export type GasolineStaffelSchemaInput = z.input<typeof gasolineStaffelSchema>;
export type GasolineStaffelSchemaOutput = z.output<typeof gasolineStaffelSchema>;

export const waterlevelStaffelSchema = z.object({
	id: z.number().nullable(),
	description: z.string().min(1).max(255),
	waterlevelMeasuringPoint: ZodSchema.requiredField(z.number()),
	staffelItems: z.array(z.object({
		id: z.number().nullable(),
		startWaterLevelCm: ZodSchema.requiredField(z.number().min(0).max(999999999)),
		endWaterLevelCm: ZodSchema.requiredField(z.number().min(0).max(999999999)),
		surcharge: ZodSchema.requiredField(z.number().min(0).max(200)),
	})),
});

export type WaterlevelStaffelSchemaInput = z.input<typeof waterlevelStaffelSchema>;
export type WaterlevelStaffelSchemaOutput = z.output<typeof waterlevelStaffelSchema>;

export const feetStaffelSchema = z.object({
	id: z.number().nullable(),
	description: z.string().min(1).max(255),
	staffelItems: z.array(z.object({
		id: z.number().nullable(),
		startFeet: ZodSchema.requiredField(z.number().min(0).max(999999999)),
		endFeet: ZodSchema.requiredField(z.number().min(0).max(999999999)),
		price: ZodSchema.requiredField(z.number().min(0).max(9999999)),
		reefer: z.boolean(),
		empty: z.boolean(),
	})),
});

export type FeetStaffelSchemaInput = z.input<typeof feetStaffelSchema>;
export type FeetStaffelSchemaOutput = z.output<typeof feetStaffelSchema>;
